import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';

export const MwFormActionsSelector = 'mw-form-actions';

@Component({
  selector: MwFormActionsSelector,
  template: `<ng-template><ng-content></ng-content></ng-template> `,
  styles: [
    `
      :host {
        display: none;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MwFormActionsComponent {
  @ViewChild(TemplateRef) templateRef: TemplateRef<any>;
}
